import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import colors from '../../styles/colors';
import { AppContext } from '../../context/AppContext';
import Icon from '../Icon';
import { IconEnum as Icons } from '../Icons';
import Loader from '../Loader';
import * as Price from '../../util/Price';
import Button from '../Button';
import NoContent1 from '../../shared/NoContent';

const TableWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const TableContainer = styled.div`
  background: ${colors.white};
  width: 100%;
  max-height: 60vh;
  height: 60vh;
  overflow: auto;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  border-radius: 0px 10px 10px 0px;
  border: 1px solid ${colors.grey6};
  position: relative;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
  @media screen and (max-width: 991px) {
    max-height: 80vh;
    height: 80vh;
  }
`;

const TableHeader = styled.div`
  display: flex;
  /* padding: 7px 25px; */
  width: fit-content;
  position: sticky;
  top: 0;
  background: ${colors.white};
  z-index: 70;
  border-bottom: 1px solid ${colors.grey6};
`;

const TableHeaderItem = styled.div`
  border-right: 1px solid ${colors.grey6};
  cursor: pointer;
  font-size: 1.2rem;
  padding: 10px;
  color: ${colors.grey3};
  display: flex;
  align-items: center;
  flex: ${(props) => props.flex || '1'};
  min-width: 210px;
  &:first-child {
    display: flex;
    position: sticky;
    top: 0;
    left: 0px;
    min-width: 210px;
    background: ${colors.white};
    z-index: 50;
    align-items: center;
    padding: 10px 20px;
  }
`;

const TableRow = styled.div`
  border-bottom: 1px solid ${colors.grey6};

  display: flex;

  width: fit-content;
  transition: all 0.1s;
  align-items: center;
  &:hover {
    background: rgba(211, 211, 211, 0.1);
  }
`;

const TableRowItem = styled.div`
  border-right: 1px solid ${colors.grey6};
  font-size: 1.4rem;
  color: ${colors.grey1};
  padding: 13px 10px;
  flex: ${(props) => props.flex || '1'};
  min-width: 210px;
  background: white;
  color: ${(props) => (props.onClick ? colors.seaGreen : null)};
  cursor: ${(props) => (props.onClick ? 'pointer' : null)};
  &:first-child {
    height: 100%;
    position: sticky;
    top: 0;
    left: 0px;
    z-index: 40;
    padding: 13px 20px;
  }
`;

const NoContentContainer = styled.div`
  height: ${(props) => props.height || '400px'};
  display: flex;
  flex-direction: ${(props) => props.direction || 'column'};
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;

const NoContentHeader = styled.div`
  font-weight: 600;
  font-size: 1.4rem;
  color: ${colors.grey1};
  margin-bottom: 10px;
`;

const NoContentText = styled.div`
  font-weight: 500;
  font-size: 1.2rem;
  color: ${colors.grey3};
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);

  z-index: 2000;
`;

const NoContentBody = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
`;

const QueryContent = styled.div`
  position: ${(props) => (props.top ? 'sticky' : null)};
  top: ${(props) => (props.top ? '0' : null)};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${(props) => props.direction || 'column'};
`;

const QueryText = styled.h4`
  width: ${(props) => props.textWidth || null};
  margin: 10px;
`;

const LoaderContainer1 = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
`;

const NoContent = ({
  contacts,
  searchQuery,
  setSearchQuery,
  height,
  direction,
  textWidth,
}) => {
  const refetchWithoutQuery = () => {
    setSearchQuery({ type: 'clear' });
  };

  return (
    <NoContentContainer height={height}>
      {searchQuery?.phoneNumber && contacts.length > 0 ? (
        <NoContentBody>
          <QueryContent top="1" direction={direction}>
            <QueryText textWidth={textWidth}>
              Displaying search results for {`"${searchQuery.phoneNumber}"`}
            </QueryText>
            <Button
              type="button"
              text="Clear filter"
              onClick={() => refetchWithoutQuery()}
              width="max-content"
              margin="5px"
              height="25px"
            />
          </QueryContent>
        </NoContentBody>
      ) : (
        <NoContentBody>
          {searchQuery?.phoneNumber ? (
            <QueryContent direction={direction}>
              <QueryText textWidth={textWidth}>
                No contacts found for {`${searchQuery.phoneNumber}`}
              </QueryText>
              <Button
                type="button"
                text="Clear filter"
                onClick={() => refetchWithoutQuery()}
                width="max-content"
                margin="5px"
                height="25px"
              />
            </QueryContent>
          ) : (
            <>
              {contacts.length < 1 && (
                <>
                  <NoContentHeader>No filter applied</NoContentHeader>
                  <NoContentText>
                    Apply at least 1 filter to get contacts
                  </NoContentText>
                </>
              )}
            </>
          )}
        </NoContentBody>
      )}
    </NoContentContainer>
  );
};
const TableHeaderCompnent = ({ ordering, ...props }) => {
  const { fieldName, order } = ordering;
  let orderingIcon = (
    <Icon
      icon={Icons.Sort}
      size={12}
      margin="5px"
      active
      activeColor={colors.grey3}
    />
  );

  if (fieldName === props.columnName && order === 'asc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortUp}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  } else if (fieldName === props.columnName && order === 'desc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortDown}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  }

  return (
    <TableHeaderItem onClick={() => props.handleSort(props.columnName)}>
      {props.children} {orderingIcon}
    </TableHeaderItem>
  );
};

export default function CustomerTable({
  contacts,
  fetchMore,
  ordering,
  handleSort,
  isMore,
  loadMoreData,
  getRefferedContactsClick,
  fetching,
  setFetching,
  filterApplied,
  searchQuery,
  setSearchQuery,
  loading,
  scrollToTop,
}) {
  const { app, setApp } = useContext(AppContext);
  const scrollContainer = React.useRef();

  const handleScroll = () => {
    if (!fetchMore) return;
    if (scrollContainer?.current.scrollTop > 0) {
      const scrollPosition = scrollContainer?.current.offsetHeight
        + scrollContainer?.current.scrollTop;
      const scrollPositionMax = scrollContainer?.current.scrollHeight - 300;
      // const { limit } = pagination;
      if (scrollPosition >= scrollPositionMax && !fetching && isMore) {
        setFetching(true);

        // await fetchMore({
        //   variables: {
        //     pagination: {
        //       limit,
        //       offset: app?.paginationOffset + 1,
        //     },
        //   },
        //   updateQuery,
        // });

        setTimeout(() => {
          loadMoreData();
          setFetching(false);
        }, 0);
      }
    }
  };

  useEffect(() => {
    if (scrollContainer?.current) {
      scrollContainer.current.scrollTop = 0;
    }
  }, [scrollToTop]);

  // The check box stuff is kind of a mess, sorry.
  // The deliverable kept changing.

  return (
    <>
      {loading ? (
        <LoaderContainer1>
          <Loader />
        </LoaderContainer1>
      ) : (
        <TableWrapper>
          {fetching && (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          )}
          {searchQuery?.phoneNumber && contacts.length > 0 && (
            <NoContent
              contacts={contacts}
              setSearchQuery={setSearchQuery}
              searchQuery={searchQuery}
              height="fit-content"
              direction="row"
            />
          )}

          {(contacts?.length > 0 && filterApplied) || fetching ? (
            <TableContainer ref={scrollContainer} onScroll={handleScroll}>
              <TableHeader>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="phoneNumber"
                >
                  PHONE
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="organizationName"
                >
                  CLIENT
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="createdAt"
                >
                  CREATED AT
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="lastImported"
                >
                  LAST IMPORT
                </TableHeaderCompnent>

                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="currentAvailableBalance"
                >
                  CURRENT AVAILABLE BALANCE
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalCreditGranted"
                >
                  TOTAL CREDIT GRANTED
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalCreditRedeemed"
                >
                  TOTAL CREDIT REDEEMED
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalCouponsGranted"
                >
                  TOTAL DISCOUNTS GRANTED
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalCouponsRedeemed"
                >
                  TOTAL DISCOUNTS REDEEMED
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalCouponsAcceptedRef"
                >
                  TOTAL REF DISCOUNTS ACCEPTED
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalRefClicks"
                >
                  TOTAL REF CLICKS
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalCouponsRedRef"
                >
                  TOTAL REF DISCOUNTS REDEEMED
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="totalConversionRateRef"
                >
                  TOTAL REF CONVERSION RATE
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="originalSource"
                >
                  ORIGINAL SOURCE
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="optInMethod"
                >
                  OPT-IN METHOD
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="lastOptIn"
                >
                  LAST OPT-IN
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="optOut"
                >
                  OPT-OUT
                </TableHeaderCompnent>
                <TableHeaderCompnent
                  ordering={ordering}
                  handleSort={handleSort}
                  columnName="smsCampaignOptOut"
                >
                  SMS OPT-OUT
                </TableHeaderCompnent>
              </TableHeader>

              {contacts.map((contact) => {
                const refAcceptedClickable = (contact.totalCouponsAcceptedRef > 0 && !fetching) || false;

                const redeemClickable = (contact.totalCouponsRedRef > 0 && !fetching) || false;

                return (
                  <TableRow
                    key={contact._id}
                    onClick={() => setApp({
                      ...app,
                      customerInfoContext: contact.phoneNumber,
                    })}
                  >
                    <TableRowItem>{contact.phoneNumber}</TableRowItem>
                    <TableRowItem>{contact.organizationName}</TableRowItem>
                    <TableRowItem>
                      {moment(contact.createdAt * 1000).format('L')}
                    </TableRowItem>
                    <TableRowItem>
                      {moment(contact.lastImported * 1000).format('L')}
                    </TableRowItem>

                    <TableRowItem>
                      {`$${Price.output(
                        contact.currentAvailableBalance,
                        true,
                      )}`}
                    </TableRowItem>
                    <TableRowItem>
                      {`$${Price.output(contact.totalCreditGranted, true)}`}
                    </TableRowItem>
                    <TableRowItem>
                      {`$${Price.output(contact.totalCreditRedeemed, true)}`}
                    </TableRowItem>
                    <TableRowItem>{contact.totalCouponsGranted}</TableRowItem>
                    <TableRowItem>{contact.totalCouponsRedeemed}</TableRowItem>
                    <TableRowItem
                      onClick={
                        refAcceptedClickable
                          ? () => getRefferedContactsClick({
                            phoneNumber: contact.phoneNumber,
                            couponType: 'accepted',
                            _id: contact._id,
                            organizationId: contact.organizationId,
                          })
                          : null
                      }
                    >
                      {`$${Price.output(
                        contact.totalCouponsAcceptedRef,
                        true,
                      )}`}
                    </TableRowItem>
                    <TableRowItem>{contact.totalRefClicks || '0'}</TableRowItem>
                    <TableRowItem
                      onClick={
                        redeemClickable
                          ? () => getRefferedContactsClick({
                            phoneNumber: contact.phoneNumber,
                            couponType: 'redeemed',
                            _id: contact._id,
                            organizationId: contact.organizationId,
                          })
                          : null
                      }
                    >
                      {`$${Price.output(contact.totalCouponsRedRef, true)}`}
                    </TableRowItem>
                    <TableRowItem>
                      {contact.totalConversionRateRef}%
                    </TableRowItem>
                    <TableRowItem>{contact.originalSource}</TableRowItem>
                    <TableRowItem>{contact.optInMethod}</TableRowItem>
                    <TableRowItem>
                      {contact.lastOptIn
                        ? moment(contact.lastOptIn * 1000).format('L')
                        : ''}
                    </TableRowItem>
                    <TableRowItem>
                      {contact.optOut
                        ? moment(contact.optOut * 1000).format('L')
                        : ''}
                    </TableRowItem>
                    <TableRowItem>
                      {contact.smsCampaignOptOut
                        ? moment(contact.smsCampaignOptOut * 1000).format('L')
                        : ''}
                    </TableRowItem>
                    <ReactTooltip place="right" type="dark" effect="solid" />
                  </TableRow>
                );
              })}
            </TableContainer>
          ) : (
            <NoContent1
              header={filterApplied ? 'No Contacts Found' : 'No filter Applied'}
              description={
                filterApplied
                  ? 'Please try with some other filters'
                  : 'Please apply some filters to get contacts'
              }
            />
          )}

        </TableWrapper>
      )}
    </>
  );
}

export { NoContent };
